import { TemplateEnum, ThemeEnum } from '@star/constants';

export enum NavNameEnum {
  Home = 'home',
  Video = 'video',
  Deposit = 'deposit',
  Activity = 'activity',
  Mine = 'mine',
}

export type BottomTabBarType = {
  title: string;
  path: string;
  icon: string;
  activeIcon?: string;
  animationInIcon?: string;
  animationOutIcon?: string;
  name: NavNameEnum;
  show?: string;
  query?: Record<string, any>;
  params?: Record<string, any>;
  sort: number;
};

const appBottomTabBarThemeMap = {
  [ThemeEnum.LIGHT]: {
    [NavNameEnum.Home]: {
      activeIcon: 'nav_home_active_light.png',
      icon: 'nav_home.png',
      animationInIcon: 'nav_home_enter_light.webp',
      animationOutIcon: 'nav_home_leave_light.webp',
      sort: 1,
    },
    [NavNameEnum.Video]: {
      activeIcon: 'nav_video_active_light.png',
      icon: 'nav_video.png',
      animationInIcon: 'nav_video_enter_light.webp',
      animationOutIcon: 'nav_video_leave_light.webp',
      sort: 2,
    },
    [NavNameEnum.Deposit]: {
      activeIcon: 'nav_deposit_active_light.png',
      icon: 'nav_deposit.png',
      animationInIcon: 'nav_deposit_enter_light.webp',
      animationOutIcon: 'nav_deposit_leave_light.webp',
      sort: 3,
    },
    [NavNameEnum.Activity]: {
      activeIcon: 'nav_activity_active_light.png',
      icon: 'nav_activity.png',
      animationInIcon: 'nav_activity_enter_light.webp',
      animationOutIcon: 'nav_activity_leave_light.webp',
      sort: 4,
    },
    [NavNameEnum.Mine]: {
      activeIcon: 'nav_mine_active_light.png',
      icon: 'nav_mine.png',
      animationInIcon: 'nav_mine_enter_light.webp',
      animationOutIcon: 'nav_mine_leave_light.webp',
      sort: 5,
    },
  },
  [ThemeEnum.DARK]: {
    [NavNameEnum.Home]: {
      activeIcon: 'nav_home_active_dark',
      icon: 'nav_home_dark',
      sort: 1,
    },
    [NavNameEnum.Video]: {
      activeIcon: 'nav_video_dark',
      icon: 'nav_video_dark',
      sort: 2,
    },
    [NavNameEnum.Deposit]: {
      activeIcon: 'nav_deposit_active_dark',
      icon: 'nav_deposit_dark',
      sort: 3,
    },
    [NavNameEnum.Activity]: {
      activeIcon: 'nav_activity_active_dark',
      icon: 'nav_activity_dark',
      sort: 4,
    },
    [NavNameEnum.Mine]: {
      activeIcon: 'nav_mine_active_dark',
      icon: 'nav_mine_dark',
      sort: 5,
    },
  },
  [ThemeEnum.ORANGE]: {
    [NavNameEnum.Home]: {
      activeIcon: 'nav_home_active_orange.png',
      icon: 'nav_home.png',
      animationInIcon: 'nav_home_enter_orange.webp',
      animationOutIcon: 'nav_home_leave_orange.webp',
      sort: 1,
    },
    [NavNameEnum.Video]: {
      activeIcon: 'nav_video_active_orange.png',
      icon: 'nav_video.png',
      animationInIcon: 'nav_video_enter_orange.webp',
      animationOutIcon: 'nav_video_leave_orange.webp',
      sort: 2,
    },
    [NavNameEnum.Deposit]: {
      activeIcon: 'nav_deposit_active_orange.png',
      icon: 'nav_deposit.png',
      animationInIcon: 'nav_deposit_enter_orange.webp',
      animationOutIcon: 'nav_deposit_leave_orange.webp',
      sort: 3,
    },
    [NavNameEnum.Activity]: {
      activeIcon: 'nav_activity_active_orange.png',
      icon: 'nav_activity.png',
      animationInIcon: 'nav_activity_enter_orange.webp',
      animationOutIcon: 'nav_activity_leave_orange.webp',
      sort: 4,
    },
    [NavNameEnum.Mine]: {
      activeIcon: 'nav_mine_active_orange.png',
      icon: 'nav_mine.png',
      animationInIcon: 'nav_mine_enter_orange.webp',
      animationOutIcon: 'nav_mine_leave_orange.webp',
      sort: 5,
    },
  },
};

// Bigwin
const bigwin_appBottomTabBar: Omit<BottomTabBarType, 'icon' | 'activeIcon' | 'sort'>[] = [
  {
    title: '首页',
    path: '/home/103',
    name: NavNameEnum.Home,
    params: { mainType: '103' },
  },
  {
    title: '视频',
    path: '/video?key=elec',
    name: NavNameEnum.Video,
  },
  {
    title: '充值',
    path: '/wallet/deposit',
    name: NavNameEnum.Deposit,
  },
  {
    title: '活动',
    path: '/activity',
    name: NavNameEnum.Activity,
    query: { tab: '0' },
  },
  {
    title: '我的',
    path: '/mine',
    name: NavNameEnum.Mine,
  },
];

export const appBottomTabBarMap = {
  [TemplateEnum.BIGWIN]: bigwin_appBottomTabBar,
};

export const getBottomTabBarList = (template: TemplateEnum, theme: ThemeEnum) => {
  const result = appBottomTabBarMap[template]
    ?.map((item: Omit<BottomTabBarType, 'icon' | 'activeIcon' | 'sort'>) => {
      return {
        ...item,
        ...appBottomTabBarThemeMap[theme]?.[item.name],
      };
    })
    .sort((a: BottomTabBarType, b: BottomTabBarType) => a.sort - b.sort);
  console.log(result, 'getBottomTabBarList');
  return result;
};
